import { FirebaseAuthService } from './../../_guard/firebase-auth-service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(public authService: FirebaseAuthService) { }

  display = 'none';

  ngOnInit() {
  }

  menuclick() {
    if (this.display === 'block') {
      this.display = 'none';
    } else {
      this.display = 'block';
    }
  }
  // Close the sidebar with the close button
  w3_close() {
    this.display = 'none';
  }

  logout() {
    this.authService.logout();
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/header/header.component.ts